import EnquiryPublicForm from 'module/EnquiryPublicForm'
import EnquiryPublicFormSuccess from 'module/EnquiryPublicForm/EnquiryPublicFormSuccess'

export const ROUTE_NAMES = {
  ENQUIRY_PUBLIC_FORM: 'ENQUIRY_PUBLIC_FORM',
  ENQUIRY_PUBLIC_FORM_SUCCESS: 'ENQUIRY_PUBLIC_FORM_SUCCESS',
}

const EnquiryPublicFormRouting = [
  {
    childRoutes: [
      {
        component: EnquiryPublicFormSuccess,
        disableAuth: true,
        name: ROUTE_NAMES.ENQUIRY_PUBLIC_FORM_SUCCESS,
        noBreadcrumb: true,
        path: 'success/t=:token',
      },
    ],
    indexRoute: {
      component: EnquiryPublicForm,
      disableAuth: true,
      noBreadcrumb: true,
    },
    name: ROUTE_NAMES.ENQUIRY_PUBLIC_FORM,
    path: 'enquiry-form',
  },
] as any

EnquiryPublicFormRouting.ROUTE_NAMES = ROUTE_NAMES

export default EnquiryPublicFormRouting
